import React, { useEffect, useState } from 'react';
import { readJourneyState } from '../../data/improvementJourney';
import { roomForProject } from '../../data/makeItHomeBundles';
import MakeItHomeBundles from './MakeItHomeBundles';

/**
 * ProjectCompletionFurnish — the personalised completion trigger for the
 * workspace (/my-buildpilot). Reads the saved journey state (stage + project)
 * and, once a project is finishing (build) or finished (own), surfaces a
 * matched "now furnish it" set tailored to that project — opening on the room
 * the project most naturally completes (e.g. a pool/deck opens on Outdoors,
 * a new home opens on the living room).
 *
 * Renders nothing for earlier stages (dream/plan/choose) or when there is no
 * remembered project — so it only appears when it's genuinely useful.
 */
const ProjectCompletionFurnish = () => {
  const [state, setState] = useState({ stage: null, project: null });

  useEffect(() => {
    try { setState(readJourneyState()); } catch { /* ignore */ }
  }, []);

  const { stage, project } = state;
  if (!project || (stage !== 'build' && stage !== 'own')) return null;

  const label = project.label.toLowerCase();
  const finished = stage === 'own';
  const eyebrow = finished ? 'Now, let’s make it home' : 'Getting ready to move in';
  const title = finished
    ? `Your ${label} is done — now make it home`
    : `Your ${label} is nearly there — plan the finish`;
  const intro = finished
    ? `You've gone from plans to keys. Here are matched sets people reach for once they move in — swap any piece, and you buy each one direct from the retailer at their price.`
    : `While the ${label} wraps up, here's a head start on furnishing it. Matched sets gathered across brands — swap any piece, and you buy each one direct from the retailer.`;

  return (
    <div className="mb-10 rounded-3xl border border-[#e8ebef] bg-[#fafbfc] overflow-hidden" data-testid="workspace-furnish">
      <MakeItHomeBundles
        testid="workspace-make-it-home"
        eyebrow={eyebrow}
        title={title}
        intro={intro}
        initialRoom={roomForProject(project.slug)}
      />
    </div>
  );
};

export default ProjectCompletionFurnish;
